import { AlertCircle, CheckCircle, Info, X, XCircle } from "lucide-react";

// Toast component
const ToastContainer = ({ toasts, removeToast }) => (
  <div className="fixed top-4 right-4 z-50 space-y-2">
    {toasts.map((toast) => (
      <div
        key={toast.id}
        className={`flex items-center p-4 rounded-lg shadow-lg max-w-sm animate-slide-in ${
          toast.type === "success"
            ? "bg-green-100 text-green-800 border border-green-200"
            : toast.type === "error"
            ? "bg-red-100 text-red-800 border border-red-200"
            : toast.type === "warning"
            ? "bg-yellow-100 text-yellow-800 border border-yellow-200"
            : "bg-blue-100 text-blue-800 border border-blue-200"
        }`}
      >
        <div className="flex items-center">
          {toast.type === "success" && (
            <CheckCircle size={20} className="mr-2" />
          )}
          {toast.type === "error" && <XCircle size={20} className="mr-2" />}
          {toast.type === "warning" && (
            <AlertCircle size={20} className="mr-2" />
          )}
          {toast.type === "info" && <Info size={20} className="mr-2" />}
          <span className="flex-1">{toast.message}</span>
        </div>
        <button
          onClick={() => removeToast(toast.id)}
          className="ml-4 text-current opacity-70 hover:opacity-100"
        >
          <X size={16} />
        </button>
      </div>
    ))}
  </div>
);
export default ToastContainer;
